<template>
  <div :class="`chart engagement md-layout-item md-size-${width} md-medium-size-${width} md-small-size-100`">
    <div>
      <h2>{{label}}</h2>
      <div style="max-height: 330px;">
        <apexchart height=330 type="radialBar" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div class="description">{{ visitedUsers }} of {{ allUsers }} users active in the last 30 days</div>
      <div class="spacer"></div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "RecentAccessTotal",
  computed: {},
  components: {
    apexchart: VueApexCharts
  },
  mounted() {},

  data() {
    let percent = window.drupalSettings.controller.graphs.RecentAccessTotal.usersLastVisited.length / window.drupalSettings.controller.graphs.RecentAccessTotal.users.length * 100;
    return {
      label: window.drupalSettings.controller.graphs.RecentAccessTotal.label,
      width: window.drupalSettings.controller.graphs.RecentAccessTotal.width || 33,
      isGroupAdmin: window.drupalSettings.controller.groupAdmin,
      allUsers: window.drupalSettings.controller.graphs.RecentAccessTotal.users.length,
      visitedUsers: window.drupalSettings.controller.graphs.RecentAccessTotal.usersLastVisited.length,
      series: [percent],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        colors: ['#3c9ebb'],
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: "70%",
              background: '#edf7f8',
              image: undefined,
              position: "front",
              dropShadow: {
                enabled: true,
                top: 0,
                left: 0,
                blur: 4,
                opacity: 0.1
              }
            },
            track: {
              strokeWidth: "67%",
              background: '#edf7f8',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 0,
                left: 0,
                blur: 4,
                opacity: 0.2
              }
            },

            dataLabels: {
              name: {
                show: false,
              },
              value: {
                formatter: function() {
                  return window.drupalSettings.controller.graphs.RecentAccessTotal.usersLastVisited.length;
                },
                color: "#3c3c3c",
                fontSize: "47px",
                show: true
              }
            }
          }
        },
        // fill: {
        //   type: "gradient",
        //   gradient: {
        //     shade: "dark",
        //     type: "horizontal",
        //     shadeIntensity: 0.5,
        //     gradientToColors: ["#428FB1"],
        //     inverseColors: true,
        //     opacityFrom: 1,
        //     opacityTo: 1,
        //     stops: [0, 100],
        //     colorStops: []
        //   }
        // },
        stroke: {
          lineCap: "round"
        },
        labels: [""]
      }
    };
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
  .description {
    font-family: $font-source-sans-pro;
    padding-bottom: 10px;
    margin-top: -30px;
  }
</style>
